<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Valores</h5>

      <!-- <b-button
        v-if="hasPermission('adicionar_valores')"
        variant="primary"
        class="d-flex align-items-center"
        @click="irParaCadastro"
      >
        <i class="bi bi-plus-circle-fill mr-2" title="Novo Valor"></i>
      </b-button> -->
    </div>

    <!-- Filtros -->
    <div class="d-flex mb-3" style="gap: 10px;">
      <input
        v-model="filters.tipo"
        placeholder="Filtrar por Tipo"
        class="form-control"
        @input="filtrar"
      />
      <b-button
        variant="secondary"
        class="d-flex align-items-center"
        @click="limparFiltros"
      >
        <i class="bi bi-funnel mr-2" title="Limpar Filtros"></i>
      </b-button>
    </div>

    <!-- Tabela customizada -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('tipo')">
              Tipo {{ arrow('tipo') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('valor')">
              Valor (R$) {{ arrow('valor') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('data')">
              Data {{ arrow('data') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('ativo')">
              Status {{ arrow('ativo') }}
            </button>
          </th>
          <th class="text-end">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="v in valores" :key="v.id">
          <td>{{ v.tipo }}</td>
          <td>{{ utils.formatarValor(v.valor) }}</td>
          <td>{{ utils.formatarData(v.data) }}</td>
          <td>{{ v.ativo ? 'Ativo' : 'Inativo' }}</td>
          <td class="text-end">
            <i
              v-if="hasPermission('detalhar_valores')"
              class="bi bi-eye-fill text-primary mx-2"
              title="Detalhar"
              @click="detalharValor(v.id)"
            ></i>
            <i
              v-if="hasPermission('alterar_valores')"
              class="bi bi-pencil-fill text-warning mx-2"
              title="Editar"
              @click="editarValor(v.id)"
            ></i>
            <i
              v-if="hasPermission('excluir_valores')"
              class="bi bi-trash-fill text-secondary disabled"
              title="Não é permitido excluir"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <div>
        Mostrando {{ startRow }} a {{ endRow }} de {{ totalItems }} registros
      </div>
      <div class="d-flex align-items-center" style="gap: .5rem;">
        <b-form-select
          v-model="limit"
          :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
          size="sm"
          style="width: 6rem"
          @change="changeLimit"
        />
      </div>
      <div class="d-flex align-items-center">
        <b-pagination
          v-model="page"
          :per-page="limit"
          :total-rows="totalItems"
          size="sm"
          limit="5"
          @input="load"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { BButton, BPagination, BFormSelect } from 'bootstrap-vue-next'
// import axios from '@/services/axios'
import { useSortableTable } from '@/utils/useSortableTable'
import { usePermissions } from '@/composables/usePermissions'
import globalUtils from '@/utils/globalUtils'

const router = useRouter()
// const { proxy } = getCurrentInstance()
const { fetchPermissions, hasPermission } = usePermissions()

const {
  items: valores,
  totalItems,
  page,
  limit,
  filters,
  load,
  sort,
  arrow
} = useSortableTable(
  '/financeiro/valores',
  { key: 'data', order: 'desc' }
)

const pageOptions = [10,15,20,25,50]
const startRow = computed(() => (page.value-1)*limit.value+1)
const endRow   = computed(() => Math.min(page.value*limit.value, totalItems.value))
const utils = globalUtils

// filtros
function filtrar() {
  page.value = 1
  load()
}
function limparFiltros() {
  filters.value = { tipo: '', ativo: null }
  page.value = 1
  load()
}
function changeLimit() {
  page.value = 1
  load()
}

// ordenação
function changeSort(field) {
  sort(field)
}

// navegação e CRUD
// function irParaCadastro() {
//   router.push('/financeiro/valores/novo')
// }
function detalharValor(id) {
  router.push(`/financeiro/valores/${id}/detalhar`)
}
function editarValor(id) {
  router.push(`/financeiro/valores/${id}`)
}
// async function excluirValor(id) {
//   const ok = await proxy.$confirm('Tem certeza que deseja excluir este valor?','Confirmação')
//   if (!ok) return
//   await axios.delete(`/financeiro/valores/${id}`)
//   proxy.$toast.success('Valor excluído!')
//   load()
// }

watch(page,  (n,o) => n!==o && load())
watch(limit,(n,o) => { if(n!==o){ page.value=1; load() }})

onMounted(async () => {
  await fetchPermissions()
  filters.value = { tipo: '', ativo: null }
  load()
})
</script>

<style scoped>
:deep(.pagination.pagination-sm .page-link) {
  padding: rem rem;
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}
.table-hover tr:hover { background-color: var(--bs-light); }
</style>
